import { useState } from 'react';
import { useUser } from '../../auth/AuthProvider';
import { isManager } from '../../data/domain';
import { useClients } from '../../data/hooks';
import { navigate } from '../../lib/router';
import { clientPath } from '../../app/routes';
import { Icon } from '../../ui/Icon';
import { EmptyState, PageHeading, View } from '../../ui/View';
import { ClientModal } from './ClientModal';

export function ClientsView() {
  const user = useUser();
  const clients = useClients();
  const [query, setQuery] = useState('');
  const [adding, setAdding] = useState(false);
  const term = query.trim().toLowerCase();
  const matches = clients.filter((client) => [client.name, client.type, client.contact, client.phone, client.email, client.address, client.notes].join(' ').toLowerCase().includes(term));

  return (
    <View id="clients">
      <PageHeading eyebrow="Client CRM" title="Client records" subtitle="Search contacts, property details, notes, service history and documents.">
        {isManager(user) && <button className="btn btn-primary" id="addClient" onClick={() => setAdding(true)}><Icon name="plus" size={16} />Add client</button>}
      </PageHeading>
      <div className="toolbar">
        <label className="search-field toolbar-grow">
          <Icon name="search" />
          <input id="clientSearch" type="search" placeholder="Search name, contact, address or phone" value={query} onChange={(event) => setQuery(event.target.value)} aria-label="Search clients" />
        </label>
        <p className="hint toolbar-hint">{term ? `${matches.length} of ${clients.length} clients` : `${clients.length} clients`}</p>
      </div>
      <div className="panel">
        <div className="row-list" id="clientResults">
          {matches.length ? matches.map((client) => (
            <button className="row row-button client-row" key={client.id} onClick={() => navigate(clientPath(client.id))}>
              <span className="row-text"><b>{client.name}</b><small>{client.contact || 'Contact not recorded'}</small></span>
              <span className={`badge ${client.type === 'High risk' || client.highRisk ? 'badge-danger' : client.type === 'Commercial' ? 'badge-info' : 'badge-neutral'}`}>{client.type}</span>
              <small className="client-address">{client.address || 'No address recorded'}</small>
              <Icon name="chevronRight" className="icon row-chevron" />
            </button>
          )) : <EmptyState>{clients.length ? 'No matching client records.' : 'No client records yet.'}</EmptyState>}
        </div>
      </div>
      {adding && <ClientModal client={null} onClose={() => setAdding(false)} onSaved={(client) => { setAdding(false); navigate(clientPath(client.id)); }} />}
    </View>
  );
}
